<template>
  <div class="send-comment-wrap">
    <div class="flex-1 w-embed">
      <input
        ref="input"
        :value="value"
        class="comment-input"
        type="text"
        placeholder="Add comment"
        @input="change($event.target.value)"
        @keyup.enter="send"
      />
    </div>
    <Button size="small" class="flex-centering" @click="send">
      <!-- Immutable button width  -->
      <Spinner v-if="loading" size="20" class="send-comment-spinner" />
      <span :style="{ opacity: loading ? '0' : '1' }">{{ $t('Send') }}</span>
    </Button>
  </div>
</template>

<script>
  import factory from '@/utils/api/factory';
  import parseError from '@/utils/formatting/parse-error';
  import t from '@/i18n';
  import Spinner from 'vue-simple-spinner';
  import { mapState } from 'vuex';
  import Button from '@/components/ui/Button';

  export default {
    name: 'CommentInput',
    components: { Spinner, Button },
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      value: String,
      context: {
        type: Object,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        val: this.value || '',
      };
    },
    computed: mapState({
      user: (state) => state.auth.user?.id,
      username: (state) => state.auth.username,
    }),
    watch: {
      value(val) {
        this.val = val;
      },
    },
    mounted() {
      this.focus();
    },
    methods: {
      focus() {
        this.$refs.input.focus();
      },
      change(val) {
        this.val = val;
        this.$emit('change', val);
      },
      async send() {
        if (!this.context && !this.loading) {
          this.$emit('send');
          return;
        }

        if (!this.context?.rowId || !this.context?.fieldName) return;

        const data = {
          text: this.val,
          field: this.context.fieldName,
        };
        if (!this.user && this.username) data.user_name = this.username;
        try {
          await factory('rows').postInResourcePath(this.context.rowId, 'comments', data);

          this.context?.changeCommentCount?.();
          this.$emit('close');
        } catch (e) {
          console.error(parseError(e)) || t('Unexpected error'); // eslint-disable-line
          this.$emit('close');
        }
      },
    },
  };
</script>
